import React, { useEffect } from 'react';
import { Button, makeStyles } from '@material-ui/core';

import Card from 'components/StyledCard';

import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import 'translations/translations';
import { useTranslation } from 'react-i18next';
import { organizationActions } from 'actions/organizationActions';

import OverlaySpinner from 'components/spinners/OverlaySpinner';

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    padding: 0,
    display: 'flex',
    minHeight: '10rem',
  },
  button: {
    margin: 'auto',
    width: '100%',
  },
  buttonContainer: {
    backgroundColor: 'white ',
    textAlign: 'center',
    position: 'absolute',
    margin: 'auto',
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
  },
  image: {
    display: 'block',
    marginBottom: 'auto',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '100%',
  },
}));

const UploadLogoCard: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation(['translations']);
  const dispatch = useDispatch();

  const { organizationId, logo } = useSelector((state: ApplicationState) => ({
    organizationId: state.organization?.organization?.organizationId,
    logo: state.organization?.logo,
  }));

  useEffect(() => {
    if (organizationId) {
      dispatch(organizationActions.getOrganizationLogo(organizationId));
    }
  }, [organizationId]);

  const handleUploadLogo = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];

      if (file && organizationId) {
        dispatch(
          organizationActions.updateOrganizationLogo(organizationId, file),
        );
      }
    }
  };

  return (
    <OverlaySpinner isLoading={logo === undefined}>
      <Card className={classes.root}>
        {logo && logo.length > 0 && (
          <img src={logo} className={classes.image} />
        )}

        <div className={classes.buttonContainer}>
          <Button
            className={classes.button}
            variant="contained"
            color="secondary"
            component="label"
          >
            {t('organization_page.organization_information.labels.upload_logo')}

            <input
              type="file"
              accept="image/jpeg,image/png"
              id="image-upload"
              onChange={handleUploadLogo}
              capture
              hidden
            />
          </Button>

          <div>Max. 500KB</div>
        </div>
      </Card>
    </OverlaySpinner>
  );
};

export default UploadLogoCard;
